import {goBack} from '@utils';
import {mapState} from 'pinia';
import {useBack} from '@store/backStore';
import {useTitle} from '../store/titleStore';

export default {
  computed: {
    ...mapState(useTitle, ['title']),
    titleLocal() {
      if (!this.title) {
        return '';
      }
      return this.$i18n.t(this.title);
    },
  },
};
